import { render, staticRenderFns } from "./status-d.vue?vue&type=template&id=6945ed56&"
import script from "./status-d.vue?vue&type=script&lang=js&"
export * from "./status-d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports